import { render, staticRenderFns } from "./buttomTips.vue?vue&type=template&id=312ff0ea&"
import script from "./buttomTips.vue?vue&type=script&lang=js&"
export * from "./buttomTips.vue?vue&type=script&lang=js&"
import style0 from "./buttomTips.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports